<template>
    <div class="cursor-pointer " @click="handleClick">
        <el-icon size="20">
            <HomeFilled />
        </el-icon>
    </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { HomeFilled } from '@element-plus/icons-vue'
import { ElIcon } from 'element-plus'


const handleClick = () => {
    window.location.href = '/home'
}
</script>
